export const EDIT_UNIT_LEADER_DETAILS = {
  CLINIC_LOCATION: "clinicLocation",
  UNIT_NUMBER: "unitNumber",
  LEADER_NAME: "leaderName",
  LEADER_EMAIL: "email",
  LEADER_CONTACT: "leaderContact",
};
